module.exports = __webpack_public_path__ + "static/media/KitchenCabinet_After.7d976f81.jpg";